// extracted by mini-css-extract-plugin
module.exports = {"container":"_nE","item":"_nF","current":"_nG","big":"_nH"};